import {useLocation, useOutletContext} from "react-router-dom";
import {ViewDocumentsSubPage} from "document/component/container";

const ViewSubaglomeracionDocumentsSubPage = () => {
    let subaglomeracion;
    [subaglomeracion] = useOutletContext();

    const location = useLocation();
    const basePath = location.pathname.split("/subaglomeracions/")[0];

    return (
        subaglomeracion && (
            <ViewDocumentsSubPage
                entity={subaglomeracion}
                basePath={`${basePath}/subaglomeracions`}
            />
        )
    );
};

export default ViewSubaglomeracionDocumentsSubPage;
